import { useState } from 'react';
import React from 'react'
import { Row, Col, Card, CardBody, CardHeader, Button, Collapse, Table, FormGroup, Label, Input, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { FaChevronUp, FaChevronDown, FaFilePdf, FaFileExcel } from 'react-icons/fa';
import uuid from 'react-uuid';
import OpenActionSummaryItem from '../AllFarmsSummary/OpenActionSummaryItem';
import moment from "moment";
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const OpenActionSummary = ({ openActionSupplierList, farmsList, openActionList, openActionsList }) => {
    const [isOpen, setIsOpen] = useState(true); const [isIconUp, setIsIconUp] = useState(true); const [farmId, setFarmId] = useState(0); const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [tempOpenActionList, setTempOpenActionList] = useState(openActionList); const [openActionItems, setOpenActionItems] = useState(openActionList);
    const [tempOpenActionsList, setTempOpenActionsList] = useState(openActionsList); const [openActionsItems, setOpenActionsItems] = useState(openActionsList);
    const [tempOpenActionSupplierList, setTempOpenActionSupplierList] = useState(openActionSupplierList); const [openActionSupplieritems, setOpenActionSupplieritems] = useState(openActionSupplierList);
    const toggle = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    const [isGroupBy, setIsGroupBy] = useState(false); const [isExpand, setIsExpand] = useState(false);
    const [name, setName] = useState('');
    const [tempOpenActionsItems, setTempOpenActionsItems] = useState(openActionsList);
    const [tempOpenActionItems, setTempOpenActionItems] = useState(openActionList);
    const [tempOpenActionSupplieritems, setTempOpenActionSupplieritems] = useState(openActionSupplierList);
    const [farmItems, setFarmItems] = useState(farmsList);

    const handleFarmIdChange = (e) => {
        setFarmId(e.target.value)
        if (parseInt(e.target.value) == 0) {
            setOpenActionItems(tempOpenActionList);
            setOpenActionsItems(tempOpenActionsList);
            setOpenActionSupplieritems(tempOpenActionSupplierList);
        }
        else {
            var list = tempOpenActionList.filter(x => x.farmId == parseInt(e.target.value));
            var list1 = tempOpenActionSupplierList.filter(x => x.id == parseInt(e.target.value));
            var list2 = tempOpenActionsList.filter(x => x.farmId == parseInt(e.target.value));
            setOpenActionItems(list);
            setOpenActionSupplieritems(list1);
            setOpenActionsItems(list2);
        }
    }

    const exportFarmListToExcel = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportReportExcel();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportReportExcel = async (e) => {

        var selectedFarmlist = farmItems.map(r => r.uniqueIdentifier).join(",");

        const response = await apiGet(
            '/api/allFarmsSummary/GenerateReportOpenActionsExcel/', {
                params: { userId: userId, farmId: farmId, farmList: selectedFarmlist }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/vnd.ms-excel" })

            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            var currentDate = new Date();
            link.download = "FWFP Open Actions " + moment(currentDate).format('DD-MM-YYYY')+ ".xlsx";
            document.body.appendChild(link)
            link.click()
        }

    }

    const exportFarmListToPdf = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportReportPdf();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportReportPdf = async (e) => {
        const response = await apiGet(
            '/api/allFarmsSummary/GenerateReportOpenActionsPDF/', {
                params: { userId: userId, farmId: farmId }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "OpenActions.pdf";
            document.body.appendChild(link)
            link.click()
        }

    }

    const base64ToArrayBuffer = (data) => {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }
    const handleChangeName = async (event) => {
        setName(event.target.value);
        if (event.target.value == '') {
            setOpenActionsItems(tempOpenActionsItems);
            var list2 = [];
            tempOpenActionItems.forEach(item => {
                //item.openActionsList = { ...item.tempOpenActionsList };
                var list3 = [];
                item.tempOpenActionsList.forEach(item1 => {
                    list3.push(item1);
                }
                );
                item.totalOpenAction = list3.length;
                item.openActionsList = list3;
                list2.push(item);
            });
            setOpenActionItems(list2);
            setOpenActionSupplieritems(tempOpenActionSupplieritems);
        }
        else {
            var list = [];
            var listMain = [];
            var listHeader = [];
            list = tempOpenActionsItems.filter(x => (x.description.toLowerCase().includes(event.target.value.toLowerCase()) || (x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(event.target.value.toLowerCase()) : 0)));
            setOpenActionsItems(list);

            tempOpenActionItems.forEach(item => {
                var list1 = [];
                list1 = item.tempOpenActionsList.filter(x => (x.description.toLowerCase().includes(event.target.value.toLowerCase())));
                item.openActionsList = list1;
                item.totalOpenAction = list1.length;
                var farm = tempOpenActionSupplieritems.filter(x => x.id == item.farmId)[0];
                if (list1.length > 0) {
                    listMain.push(item);
                    listHeader.push(farm);
                }
            })
            setOpenActionSupplieritems(listHeader);
            setOpenActionItems(listMain);
        }
    }

    const itemsPerPage = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    return (
        <div>
            <Row style={{ marginTop: `15px` }}>
                <Col>
                    <Card className="my-4 flex-grow-1 d-flex flex-column" style={{ maxHeight: "100vw" }}>
                        <CardHeader className="item-header" onClick={toggle}>
                            <Row>
                                <Col sm="11"><h6>Open Actions
                                    <Button style={{ float: "right", background: "none", border: "none" }} onClick={(e) => exportFarmListToExcel(e)} value="Export" placeholder="">
                                        <img src="/images/Excel_icon.png" className="card_icon" ></img>
                                    </Button>
                                </h6></Col>
                                <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Collapse isOpen={isOpen}>
                                <div>
                                    <Row>
                                        <Col sm="4">
                                            <Label for="farmId">Select Vineyard</Label>
                                            {openActionSupplierList == undefined && <p><em>Loading...</em></p>}
                                            {openActionSupplierList != undefined && openActionSupplieritems != null &&
                                                <Input className="validate" type="select" value={farmId} onChange={(e) => handleFarmIdChange(e)} name="farmId" id="farmId">
                                                    <option key={uuid()} value="0">All Vineyards</option>
                                                    {openActionSupplierList.map(items =>
                                                        <option key={uuid()} value={items.id}>{items.name}</option>
                                                    )}
                                                </Input>
                                            }
                                        </Col>
                                        <Col sm="4">
                                            <br/>
                                            <Input type="checkbox" checked={isGroupBy} onChange={(e) => setIsGroupBy(!isGroupBy)} name="isGroupBy" id="isGroupBy" />&nbsp;
                                            <Label for="name">List Actions Only</Label>
                                        </Col>
                                        <Col sm="4">
                                            <FormGroup>
                                                <Label style={{ textTransform: "none", fontSize: "medium" }}>Search</Label>
                                                <Input className="validate" type="text" value={name} onChange={handleChangeName} name="Name" id="Name" placeholder="" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <div>
                                            {!isGroupBy && 
                                                openActionSupplieritems.map(summary =>
                                                    <OpenActionSummaryItem expand={isExpand} key={summary.id} itemObj={summary} itemObjList={openActionItems.filter(x => x.farmId == summary.id)}>
                                                    </OpenActionSummaryItem>
                                                )
                                            }
                                        </div>
                                        <div>
                                            {
                                                isGroupBy &&
                                                <>
                                                    <Table id="tblDocumentList" striped bordered hover style={{ width: '100%' }}>
                                                        <thead className="textAlignCenter">
                                                            <tr>
                                                                <th style={{ width: "10%"}}>Due Date</th>
                                                                <th style={{ width: "25%" }}>Vineyard Name</th>
                                                                <th style={{ width: "10%" }}>ID</th>
                                                                 <th style={{ width: "20%" }}>Item</th>
                                                                 <th style={{width:"20%",textAlign:"left"}}>Description</th>
                                                            </tr>

                                                        </thead>
                                                        <tbody className="documentList textAlignCenter" id="documentList">
                                                            {openActionsItems != undefined && openActionsItems != null &&
                                                                openActionsItems.slice(indexOfFirstItem, indexOfLastItem) != undefined && openActionsItems.slice(indexOfFirstItem, indexOfLastItem) != null &&
                                                                openActionsItems.slice(indexOfFirstItem, indexOfLastItem).map(summary =>
                                                                /*{openActionsItems != undefined && openActionsItems.length > 0 && openActionsItems.map(summary =>*/
                                                                <tr key={uuid()}>
                                                                    <td>{summary.actionTypeName == "Improvement" ? moment(summary.dueDate).format('DD/MM/YYYY') : 'Ongoing / Management'}</td>
                                                                    <td>{summary.farmName}</td>
                                                                    <td>{summary.uniqueIdentifier}</td>
                                                                    <td>{summary.itemName == "Map Centre" ? "Entire Property" : summary.itemName}</td>
                                                                     <td style={{ textAlign: "left" }}>{summary.description}</td>
                                                                </tr>
                                                            )
                                                            }
                                                        </tbody>
                                                    </Table>
                                                    <Pagination>
                                                        <PaginationItem disabled={currentPage === 1}>
                                                            <PaginationLink previous onClick={() => handlePageChange(currentPage - 1)} />
                                                        </PaginationItem>
                                                        {[...Array(Math.ceil(farmsList.length / itemsPerPage))].map((item, index) => (
                                                            <PaginationItem key={index} active={currentPage === index + 1}>
                                                                <PaginationLink onClick={() => handlePageChange(index + 1)}>{index + 1}</PaginationLink>
                                                            </PaginationItem>
                                                        ))}

                                                        <PaginationItem disabled={currentPage === Math.ceil(farmsList.length / itemsPerPage)}>
                                                            <PaginationLink next onClick={() => handlePageChange(currentPage + 1)} />
                                                        </PaginationItem>
                                                    </Pagination>
                                                </>
                                            }
                                        </div>
                                    </Row>
                                </div>
                            </Collapse>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}
export default OpenActionSummary;